import ReceivedTextMessage from './TextMessage/ReceivedTextMessage';
import SentTextMessage from './TextMessage/SentTextMessage';
import { getMessageTime } from '../../../utils/time';

interface TextMessageProps {
  id: number;
  direction: string;
  created: string;
  msg: string;
  error?: boolean;
  isEncrypted?: boolean;
  isKeyExchange?: boolean;
  senderUsername?: string;
  isUnverified?: boolean;
  isSatellite?: boolean;
  lat?: string;
  lng?: string;
}

const TextMessage = ({
  id,
  direction,
  created,
  msg,
  error, lat, lng,
  isEncrypted,
  isKeyExchange,
  senderUsername,
  isUnverified,
  isSatellite,
}: TextMessageProps) => {
  const { time } = getMessageTime(created);

  if (direction === 'received') {
    return (
      <ReceivedTextMessage
        id={id}
        created={created}
        time={time}
        msg={msg}
        isEncrypted={isEncrypted}
        isKeyExchange={isKeyExchange}
        senderUsername={senderUsername}
        isUnverified={isUnverified}
        isSatellite={isSatellite}
        lat={lat} lng={lng} />
    );
  } else {
    return (
      <SentTextMessage
        id={id}
        created={created}
        time={time}
        msg={msg}
        error={error}
        isEncrypted={isEncrypted}
        isSatellite={isSatellite}
        lat={lat} lng={lng} />
    );
  }
};

export default TextMessage;
